/**
 * Type guard function that checks if a value is a string.
 * Returns true if the value is a string, false otherwise.
 *
 * @param value - The value to check
 * @returns True if the value is a string, false otherwise
 *
 * @example
 * ```ts
 * import { StringQ } from "@pdfking/structs"
 *
 * const str = "hello";
 * const num = 42;
 *
 * if (StringQ(str)) {
 *   console.log(str.toUpperCase()); // "HELLO" (type narrowed to string)
 * }
 *
 * if (StringQ(num)) {
 *   // This block won't execute
 * }
 *
 * // Use in filtering
 * const mixed = [1, "two", 3, "four"];
 * const strings = mixed.filter(StringQ); // ["two", "four"]
 * ```
 */
export const StringQ = <T>(value: T): value is string & T => typeof value === "string"
